<template>
  <v-container>
      <v-row justify="center" alignment="center">
          <v-col cols="1" v-show="$vuetify.breakpoint.mdAndUp">
              <v-img
                :src="lashesLeft.src"
                contain
                :max-height="lashHeight"
              ></v-img>
          </v-col>
          <v-col cols="auto" class="text-white heading-block">
              <div class="green-slant"><h1 class="center-text arla-strong" :class="{'small-heading': $vuetify.breakpoint.mdAndDown}">{{heading}}</h1></div>
          </v-col>
          <v-col cols="1" v-show="$vuetify.breakpoint.mdAndUp">
              <v-img
                :src="lashesRight.src"
                contain
                :max-height="lashHeight"
              ></v-img>
          </v-col>
      </v-row>
      <v-row justify="center" alignment="center">
          <v-col cols="auto" class="text-green" v-html="privacyData.contents">
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
import privacyData from "../data/privacy.json"
  export default {
    data: () => ({
      name : 'privacy',
      privacyData : privacyData.payload[0],
      heading: "Privacy Policy",
      introText: "",
      lashesRight : {src:require('../assets/lashesRight.png')},
      lashesLeft : {src:require('../assets/lashesLeft.png')},
      lashHeight: '54px',
    }),
    mounted() {
        console.log(privacyData)
    },
  }
</script>